import { __extends, __assign } from 'tslib';
import React__default from 'react';
import clsx from 'clsx';
import colors from '../../util/colors.js';
import { ContextualAlertButton } from '../ContextualAlertButton/ContextualAlertButton.component.js';
import { CloseTimer } from '../CloseTimer/CloseTimer.component.js';
import { propTypes, defaultProps } from './Toast.types.js';
import './Toast.scss.js';
import styles from './Toast.module.scss.js';

var colorMap = {
    success: colors.success80,
    warning: colors.warning90,
    danger: colors.danger80,
    informative: colors.informative80,
};
var Toast = /** @class */ (function (_super) {
    __extends(Toast, _super);
    function Toast() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Toast.prototype.render = function () {
        var _a = this.props, title = _a.title, content = _a.content, buttonText = _a.buttonText, variant = _a.variant, onClose = _a.onClose, onClick = _a.onClick, autoClose = _a.autoClose, className = _a.className, dataTestId = _a["data-testid"];
        var variantClass = styles['Toast___' + variant];
        var isLargeToast = Boolean(autoClose);
        return (React__default.createElement("div", { className: clsx(styles.Toast, variantClass, isLargeToast && styles.Toast___large, className), 
            // Notifications & toasts should have role='alert' for accessibility:
            // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_alert_role
            role: "alert", "data-testid": dataTestId },
            onClose && autoClose && (React__default.createElement("div", { className: styles.Toast_closeButton },
                React__default.createElement(CloseTimer, { color: colorMap[variant || 'warning'], duration: autoClose, onClick: onClose, isToast: true }))),
            React__default.createElement("div", { className: title && styles.Toast_title, title: title }, title),
            React__default.createElement("div", { className: styles.Toast_content }, content),
            onClick && buttonText && (React__default.createElement("div", { className: styles.Toast_button },
                React__default.createElement(ContextualAlertButton, { onClick: onClick, variant: variant || 'warning', name: buttonText }, buttonText)))));
    };
    Toast.displayName = 'Toast';
    Toast.propTypes = propTypes;
    Toast.defaultProps = __assign({}, defaultProps);
    return Toast;
}(React__default.Component));

export { Toast as default };
